import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import ProtectedRoute from "./components/ProtectedRoute"; // Ensure this path is correct
import BaseLayout from "./layout/Base";

// Pages
import HomePageOne from "./pages/HomePageOne";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import PaymentPage from "./pages/PaymentPage";
import WishlistPage from "./pages/WishlistPage";
import OrdersPage from "./pages/OrdersPage";
import ProfilePage from "./pages/ProfilePage";
import AddressPage from "./pages/AddressPage";
import LazmyWallet from "./pages/LazmyWallet";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUpPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import RegisterStep1 from "./components/Register/RegisterStep1";
import RegisterStep2 from "./components/Register/RegisterStep2";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import CategoryProducts from "./components/CategoryProducts";
import NotFound from "./components/NotFound";
import SalesPage from "./pages/SalesPages";
import AboutUs from "./pages/TopHeaderPages/AboutUs";
import FreeDelivery from "./pages/TopHeaderPages/FreeDelivery";
import ReturnsPolicy from "./pages/TopHeaderPages/ReturnsPolicy";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />
      <Routes>
        <Route element={<BaseLayout />}>
          {/* Top Header Routes */}
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/free-delivery" element={<FreeDelivery />} />
          <Route path="/returns-policy" element={<ReturnsPolicy />} />

          {/* Public Routes */}
          <Route path="/" element={<HomePageOne />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/salespages/:categorySlug" element={<SalesPage />} />

          <Route path="/category/:categoryId" element={<CategoryProducts />} />
          <Route path="/category/not-found" element={<NotFound />} />
          {/* Updated */}
          <Route path="/product/:slug" element={<ProductDetailsPageOne />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog-details" element={<BlogDetailsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* authentication routes */}
          <Route path="/phone-number-verfication" element={<RegisterStep1 />} />
          <Route path="/otp-verification" element={<RegisterStep2 />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotPassword" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/wishlist" element={<WishlistPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/address" element={<AddressPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/wallet" element={<LazmyWallet />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
